<template>
   <div class="dashboard-wrapper">
      <div id="map-wrapper">
         <map-div/>
      </div>
      <div id="top-right-infographics">
         <infographics-card :data="getRenewableEnergyTechInfo" />
      </div>

      <div id="bottom-row-infographics">
         <div id="pop-stats-container">
            <population-card :data="getPopulationInfo"/>
         </div>
         <div id="pop-trend-container">
            <chart :chart-data="getPopulationChartData"/>
         </div>
         <div id="infrastructure-info-container">
            <infographics-card :data="getPhysicalInfrastructureInfo" vertical/>
         </div>
         <div id="landuse-info-container">
            <infographics-card :data="getLanduseInfo" vertical/>
         </div>
         <div class='energy-charts' v-for="(chartData,index) in getEnergyChartsData" :key="index">
            <chart :chart-data="chartData"/>
         </div>
         <div v-if="getCookingImprovementData">
            <cooking-improvement-table/>
         </div>
      </div>
   </div>
</template>

<script>
import MapDiv from "../../../organisms/Home/Map";
import InfographicsCard from '../../../organisms/Home/InfographicsCard';
import PopulationCard from '../../../organisms/Home/PopulationCard';
import Chart from '../../../organisms/Home/Chart';
import CookingImprovementTable from '../../../organisms/Home/CookingImprovementTable';
import { mapGetters } from 'vuex';

export default {
   name: "home",
   components: {
      MapDiv,
      Chart,
      PopulationCard,
      InfographicsCard,
      CookingImprovementTable,
   },
   computed: {
      ...mapGetters('infographics', [
         'getRenewableEnergyTechInfo',
         'getPhysicalInfrastructureInfo',
         'getLanduseInfo',
         'getPopulationChartData',
         'getPopulationInfo',
         'getEnergyChartsData',
         "getCookingImprovementData",
      ]),
   },
}
</script>

<style lang="scss" scoped>
.dashboard-wrapper {
   height: 100%;
   display: grid;
   grid-gap: 5px;

   #map-wrapper {
      border: 1px solid lighten($secondary-color, 25%);
      border-radius: 4px;
      height: 400px;
   }

   #top-right-infographics {
      border: 1px solid lighten($secondary-color, 25%);
      border-radius: 4px;
      text-align: center;
      overflow: hidden;
      height: fit-content;
      background: white;
   }
   
   #bottom-row-infographics {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      border: none;
      height: 300px;

      > div {
         background: #ffffff;
         min-width: 100%;
         height: 100%;
         margin-right: 5px;
         border: 1px solid lighten($secondary-color, 25%);
         border-radius: 4px;
         text-align: center;
         overflow: hidden;
         padding: 3px;
      }
   }
}

@media screen and (min-width: 800px) {
   .dashboard-wrapper #bottom-row-infographics > div {
      min-width: 49%;
   }
}

@media screen and (min-width: 950px)
{
   .dashboard-wrapper
   {
      min-height: 0;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 53% 47%;

      #map-wrapper
      {
         height: auto;
         grid-column: 1/3;
      }
      #top-right-infographics {
         height: 100%;
      }
      #bottom-row-infographics {
         grid-column: 1/4;
         height: 100%;
         
         // &::-webkit-scrollbar {
         //    width: 5px;
         // }

         // /* Track */
         // &::-webkit-scrollbar-track {
         //    background: #f1f1f1;
         // }
         // /* Handle */
         // &::-webkit-scrollbar-thumb {
         //    background: #888;
         //    border-radius: 2.5px;
         // }
         // /* Handle on hover */
         // &::-webkit-scrollbar-thumb:hover {
         //    background: #555;
         // }

         > div {
            min-width: 33%;
         }
      }
   }
}
</style>